import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import ModuleContainer from '../../components/moduleContainer';

export const DataAndFiltersContainer = styled.div`
    padding: 0 16px;

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 0 24px;
    }
`;

export const SubMenu = styled(ModuleContainer)`
    padding-top: 24px;

    ${BaseStyle.Mixins.screenSizes.large} {
        padding-top: 32px;
    }

    @media print {
        display: none;
    }
`;

export const UtilityButtonsContainer = styled.div`
    display: none;

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.gaps.large};
        display: flex;
        margin-left: auto;
        padding-bottom: 4px;
        position: relative;
        top: -4px;
    }
`;

export const ReportNameHeader = styled.h4`
    ${BaseStyle.Mixins.gaps.large};
    align-items: start;
    display: flex;
    flex-direction: column-reverse;
    margin: 0;
    padding-bottom: 12px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        flex-direction: row;
    }
`;
